// extracted by mini-css-extract-plugin
export default {"world_forecast":"FieldPopular_world_forecast__5Vxpi","popular_forecast":"FieldPopular_popular_forecast__IGnDw"};